<h1 mat-dialog-title>Send copy to Email <b>{{labelResponse}}</b></h1>
<div mat-dialog-content>
    <div [formGroup]="FormaddSend">
        <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" >
          </mat-form-field>
        
          <mat-form-field appearance="fill">
            <mat-label>Send to</mat-label>
            <textarea matInput formControlName="sendto"></textarea>
          </mat-form-field>
          <section class="example-section">
            <mat-checkbox class="example-margin" formControlName="active">Active</mat-checkbox>
          
          </section>
    </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="onChangeItemTableNew()" >Save</button>
</div>
